var map = {
	"./babylon-Unselected.webp": "0544",
	"./celt-Unselected.webp": "7cbd",
	"./egypt-Unselected.webp": "4233",
	"./greek-Unselected.webp": "facf",
	"./indian-Unselected.webp": "9159",
	"./norse-Unselected.webp": "c8a9",
	"./persia-Unselected.webp": "9f6d",
	"./roman-Unselected.webp": "d799"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8c15";